module.exports = __webpack_public_path__ + "static/media/3_Illustrations-fr.28656b09.png";